import { useEffect, useState } from 'react';
import { ColProps } from 'reactstrap';

export enum ViewType {
  LIST = 'LIST',
  DETAIL = 'DETAIL'
}

/**
 * Computes layout props for responsive layout
 *
 * @param single true for single record view (no list view)
 * @param selectedId ID of selected item, if selected
 */
export function useResponsiveListDetail<T>(
  single: boolean,
  selectedId?: string
): [ColProps, ColProps, (viewType: ViewType) => void] {
  const [viewType, setViewType] = useState(selectedId ? ViewType.DETAIL : ViewType.LIST);

  // set to view DETAIL on ID change
  useEffect(() => {
    if (selectedId === undefined) {
      setViewType(ViewType.LIST);
    } else {
      setViewType(ViewType.DETAIL);
    }
  }, [selectedId]);

  // single record view
  if (single) {
    return [
      { className: 'd-none' },
      {
        xs: 12
      },
      () => {}
    ];
  }

  switch (viewType) {
    case ViewType.LIST:
      return [{ md: 3 }, { md: 9, className: 'd-none d-md-block' }, setViewType];
    case ViewType.DETAIL:
      return [{ md: 3, className: 'd-none d-md-block' }, { md: 9 }, setViewType];
  }
}
